import { overlay } from "overlay-kit";

import { AddSectionModal } from "./AddSectionModal";

import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";

type ShowAddSectionModalOptions = {
  defaultCourseId?: string | null;
  defaultTermId?: string | null;
  defaultTemplateId?: string | null;
  eventName?: string;
};

export const showAddSectionModal = ({
  defaultCourseId,
  defaultTermId,
  defaultTemplateId,
  eventName,
}: ShowAddSectionModalOptions) =>
  overlay.open(({ isOpen, unmount }) => (
    <Dialog open={isOpen} title={t("home.add_section_modal.add_section_title")} onClose={unmount}>
      <AddSectionModal
        defaultCourseId={defaultCourseId}
        defaultTemplateId={defaultTemplateId}
        defaultTermId={defaultTermId}
        eventName={eventName}
        onClose={unmount}
      />
    </Dialog>
  ));
